<template>
  <div class="login_wrapper">
    <div class="login_contanier">
      <div class="login_top">
        <div class="login_logo"></div>
      </div>
      <div class="login_wrap">
        <div class="login_right_wrap">
          <div class="login_id_form">
            <div class="login_id">
              <input type="text" name="아이디" @keyup.enter="login" v-model="parms.loginId" v-validate="'required'" placeholder="아이디">
              <div class="lo_validation" v-if="errors.has('아이디')">
                <div class="lo_tri"></div>
                  <span>{{ errors.first('아이디') }}</span>
              </div>    
            </div>
            <div class="login_pw">
              <input type="password" name="비밀번호"  placeholder="비밀번호" @keyup.enter="login" v-model="parms.password" v-validate="'required'">
              <div class="pw_validation" v-if="errors.has('비밀번호')">
                <div class="lo_tri"></div>
                  <span>{{ errors.first('비밀번호') }}</span>
              </div>     
            </div>
          </div>
          <div class="mt10">
            <div class="phonenum_btn">
              <button @click="getAuthNumber"><span>인증번호 받기</span></button>
            </div>
          </div>
          <div class="login_id_form mt20">
            <div class="login_phone">
              <input type="text" v-model="parms.authNumber" placeholder="폰인증번호 입력" class="w80-p">
              <timeCounter ref="commonTimeCounter" :startTime="authNumberTime" />
              <!-- <button><span>인증</span></button> -->
            </div>
          </div>
          <div class="mt10">
            <div class="login_btn" @click="login">
              <button><span>로그인</span></button>
            </div>
          </div>
          <div class="login_find">
            <div class="find_wrap">
              <div><a href="javascript:void(0);" @click="initPassword">비밀번호 초기화</a></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <comment v-if="false">
      코멘트다 이마리야 라떼는 마리야
    </comment>
    <initPasswordPopup />
  </div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import TimeCounter from '@/components/TimeCounter'
import InitPasswordPopup from './common/InitPasswordPopup.vue'
import '@/assets/css/login.css'

export default {
  name: 'Login',
  components: { TimeCounter, InitPasswordPopup },
  data: () => ({
    parms: {
      loginId: '',
      password: '',
      authNumber: ''
    },
    authNumberTime: 180
  }),
  methods: {
    login () {
      this.$validator.validateAll()
        .then((success) => {
          if (!success) { return; }

          window.$store
            .dispatch('Login/login', this.parms)
            .then((initPasswordYn) => {
              if (!initPasswordYn) {
                this.$router.push({name: 'OrderStatus'})
              } else {
                this.$router.push({name: 'password'})
              }
            })
            .catch(e => {
              if (e.result.status === AppConfig.LOGIN_FAIL) {
                Vue.Alert.alert('로그인에 실패하였습니다.('+ e.result.result.loginFailCount +'회)<br/>아이디,비밀번호를 확인하여 주십시오.');
              } else if (e.result.status === AppConfig.NO_ID) {
                Vue.Alert.alert('등록되지 않은 로그인ID입니다.');  
              } else if (e.result.status == AppConfig.NOT_EXIST_PHONE) {  
                this.$modal.show('updateMobilePhonePopup');
                Vue.Alert.alert('등록된 휴대전화번호가 없습니다.<br/>휴대전화번호를 입력하여 주십시오.');
              } else if (e.result.status == AppConfig.ACCOUNT_LOCKOUT) {
                Vue.Alert.alert('5회 이상 로그인에 실패하여<br/><span style="color:#FF2424;font-weight:bold;">계정상태</span>가 <span style="color:#FF2424;font-weight:bold;">잠금</span> 상태로 변경되었습니다.<br/>하단 비밀번호 초기화 기능을 이용하시거나<br/>관리자에게 문의 하십시오.');
              } else if (e.result.status == AppConfig.AUTH_NUMBER_FAIL) {
                //Vue.Alert.alert('인증번호 인증에 실패하였습니다.<br/>인증번호 재전송 후 다시 시도하여주십시오.');
                this.getAuthNumber();
              }
            })
      });
    },
    getAuthNumber () {
      this.$validator.validateAll()
        .then((success) => {
          if (!success) { return; }

          // 인증번호 전송 요청
          Vue.httpClient
          .post(AppConfig.HTTP_CONFIG.authURL + '/login/authnumber', this.parms)
          .then((response) => {
            if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
              if ( response.data.result != undefined ) {
                Vue.Alert.alert(response.data.result);
                // this.parms.authNumber = response.data.result;
              } else {
                Vue.Alert.alert('인증번호를 전송하였습니다.<br/>인증번호 입력 후 로그인을 시도해 주십시오.');
              }
              
              this.$refs.commonTimeCounter.startCounter();
            } 
          })
          .catch(e => {
            if (e.result.status === AppConfig.NOT_EXIST_PHONE) {
              this.$modal.show('updateMobilePhonePopup');
              Vue.Alert.alert('등록된 휴대전화번호가 없습니다.<br/>휴대전화번호를 입력하여 주십시오.');
            } else if (e.result.status === AppConfig.LOGIN_FAIL) {
              Vue.Alert.alert('인증번호 전송에 실패하였습니다.<br/>아이디,비밀번호를 확인하여 주십시오.');
            } 
          })                     
      });    
    },
    initPassword () {
      this.$modal.show('initPasswordPopup');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue